<p-dialog [header]="hasPassword ? ('CHANGE_PASSWORD.TITTLE' | translate) : ('CHANGE_PASSWORD.SET_PASSWORD' | translate)"
[style]="{width: '450px'}" [(visible)]="displayPasswordDialog"
    [modal]="true" [closable]="true" (onHide)="cancelChangePassword()" class="custom-dialog">

    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" class="form-container">
        <div *ngIf="hasPassword">
            <div *ngIf="showFields">
                <div class="field">
                    <label for="currentPassword" class="password-label">
                        {{ 'CHANGE_PASSWORD.CURRENT_PASSWORD' | translate }}
                    </label>
                    <p-password id="currentPassword" formControlName="Password" [feedback]="false" toggleMask
                        class="password-input">
                    </p-password>
                </div>

                <div class="field">
                    <label for="newPassword" class="password-label">
                        {{ 'CHANGE_PASSWORD.NEW_PASSWORD' | translate }}
                    </label>
                    <p-password id="newPassword" formControlName="NewPassword" [feedback]="false" toggleMask
                        class="password-input">
                    </p-password>
                </div>

                <div class="field">
                    <label for="confirmPassword" class="password-label">
                        {{ 'CHANGE_PASSWORD.CONFIRM_NEW_PASSWORD' | translate }}
                    </label>
                    <p-password id="confirmPassword" formControlName="PasswordConfirm" [feedback]="false" toggleMask
                        class="password-input">
                    </p-password>
                </div>
                <div *ngIf="changePasswordForm.hasError('passwordMismatch')" class="error-required">
                    {{ 'CHANGE_PASSWORD.DONT_MATCH' | translate }}
                </div>
            </div>
        </div>
       <div *ngIf="!hasPassword">
        <div class="field">
            <label for="newPassword" class="password-label">
                {{ 'CHANGE_PASSWORD.NEW_PASSWORD' | translate }}
            </label>
            <p-password 
                id="newPassword" 
                formControlName="NewPassword" 
                [feedback]="false" 
                toggleMask 
                class="password-input">
            </p-password>
        </div>

        <div class="field">
            <label for="confirmPassword" class="password-label">
                {{ 'CHANGE_PASSWORD.CONFIRM_NEW_PASSWORD' | translate }}
            </label>
            <p-password 
                id="confirmPassword" 
                formControlName="PasswordConfirm" 
                [feedback]="false" 
                toggleMask 
                class="password-input">
            </p-password>
        </div>
        <div *ngIf="changePasswordForm.hasError('passwordMismatch')" class="error-required">
            {{ 'CHANGE_PASSWORD.DONT_MATCH' | translate }}
        </div>
          

       </div>
                <p-footer>
                    <button type="submit" class="command-button full "
                        style="width: 90%; margin-left: 20px;margin-right: 20px" [disabled]="!changePasswordForm.valid">
                        {{ hasPassword ? ('CHANGE_PASSWORD.SAVE' | translate) : ('CHANGE_PASSWORD.SET_PASSWORD' | translate) }}
                    </button>
                </p-footer>
    </form>
</p-dialog>